import { toastManager } from "@salestrak/ui";
import { isForbiddenError } from "#app/lib/utils/is-forbidden-error";

// Standard catch-block toast for GraphQL mutations. Skips FORBIDDEN-coded
// errors — the Apollo error link in apollo-client.ts already shows the
// centralized "no access" toast for those, and toasting here too would
// double-toast every permission denial.
export function toastMutationError(err: unknown, fallback: string): void {
  if (isForbiddenError(err)) return;
  toastManager.add({ title: fallback, type: "error" });
}

// Pulls the user-facing message off a non-success union member (ValidationError,
// NotFoundError, PermissionDenied). Returns undefined when the result is null
// or doesn't carry one — caller falls back to a generic toast. Exists because
// codegen unions keep `__typename` optional, so `!== "Success"` never narrows
// the success member away and `.message` won't typecheck directly.
export function resultMessage(result: unknown): string | undefined {
  if (!result || typeof result !== "object") return undefined;
  const msg = (result as { message?: unknown }).message;
  return typeof msg === "string" && msg.length > 0 ? msg : undefined;
}
